import { render, staticRenderFns } from "./SlackIntegrationCard.vue?vue&type=template&id=722fc6a8&scoped=true"
import script from "./SlackIntegrationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SlackIntegrationCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SlackIntegrationCard.vue?vue&type=style&index=0&id=722fc6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722fc6a8",
  null
  
)

export default component.exports